/* eslint-disable no-undef */
(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('BackgroundReportsController', backgroundReports);

  backgroundReports.$inject = ['$http', 'BackgroundReportsService', 'ngTableParams', 'UserService', 'FoundationApi', 'NotificationService'];

  function backgroundReports ($http, BackgroundReportsService, ngTableParams, UserService, FoundationApi, NotificationService) {
    var vm = this;
    vm.scheduledReports = [];
    vm.loadSchedulings = loadSchedulings;
    vm.confirmDelete = confirmDelete;
    vm.removeScheduling = removeScheduling;
    vm.download = download;
    vm.downloadBackgroundReports = downloadBackgroundReports;
    vm.dateSelected = dateSelected;
    vm.filters = {
    		fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      status: 'Selecione um status',
      reportType: '0',
      userId: '0'
    };
    vm.show = false

    vm.statuses = ['Selecione um status', 'Na fila', 'Processando', 'Finalizado', 'Cancelado'];

    vm.reports = { 'history': 'Histórico', 'analytic': 'Analítico', 'triggers': 'Gatilhos', 'dailyAttendances': 'Diário de Atendimento' };

    // vm.loadSchedulings();

    function loadSchedulings () {
      var toDate = moment(vm.filters.toDate, 'DD/MM/YYYY');
      var fromDate = moment(vm.filters.fromDate, 'DD/MM/YYYY');
      if (toDate < fromDate) {
        NotificationService.warningHandler('', 'A data de início deve ser menor ou igual a data de fim!');
        return false;
      }
      loadTable();
    }

    function loadTable () {
      vm.historyTable = new ngTableParams({
        page: 1,
        count: 25
      }, {
        getData: function ($defer, params) {
          vm.filters['page'] = params.url()['page'];
          vm.filters['count'] = params.url()['count'];
          BackgroundReportsService
            .getSchedulings({ filters: vm.filters })
            .$promise
            .then(function (response) {
              if (response.total) {
                $defer.resolve(response.scheduledReports);
                params.total(response.total);
                vm.total = response.total;
                vm.scheduledReports = response.scheduledReports;
                vm.show = true
                return true
              }
              vm.show = false
              return false
            })
            .catch(function (response) {
              NotificationService.errorHandler(response, 'Erro ao carregar os relatórios agendados.');
            });
        }
      });
    }

    vm.getAllUsersByRole = function () {
      vm.usersCopy = [];
      UserService.searchUserByRole()
        .$promise
        .then(function (data) {
          data.forEach(function (user) {
              	if (user.inactive_since != null) {
              user.name = user.name + ' (Inativo)'
            }
          })
          vm.users = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao carregar usuários.')
        })
    }

    vm.getAllUsersByRole();

    function confirmDelete (scheduling) {
      vm.deleting = scheduling;
      FoundationApi.publish('schedulingConfirmDeleteModal', 'open');
    }

    function removeScheduling () {
      BackgroundReportsService
        .delete({
          id: vm.deleting._id
        })
        .$promise
        .then(function (data) {
          if (data.success == true) {
            NotificationService.successHandler({}, 'Agendamento cancelado com sucesso!');
            loadSchedulings();
          } else {
            NotificationService.warningHandler(data, 'Erro ao apagar agendamento. Consulte o suporte.');
          }
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao apagar agendamento. Consulte o suporte.');
        });
      FoundationApi.publish('schedulingConfirmDeleteModal', 'close');
    }

    function download (scheduling) {
      $http.get(apiUrl + '/reports/background-reports/download', {
        params: scheduling
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success === false) {
            NotificationService.errorHandler(data, 'Erro ao baixar relatório.');
            return;
          }

          if (data) {
            var filename = headers('Mktzap-Filename') || 'relatorio.csv';

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' });
            angular.element(document.body).append(anchor);

            var blob = new Blob([data], { type: headers('Content-type') });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove();
            URL.revokeObjectURL(csvUrl);
          } else {
            NotificationService.errorHandler(null, 'Não foram encontrados dados para os filtros aplicados.');
          }
        }, function ({ data, status, headers, config }) {
          if (status == 403) { NotificationService.warningHandler(data, 'Erro ao baixar relatório.'); } else { NotificationService.errorHandler(data, 'Erro ao baixar relatório.'); }
        })
    };

    function dateSelected (type, date) {
    		if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
    		}
    		if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
    		}
    };

    function downloadBackgroundReports (url) {
      if (!url) {
        NotificationService.errorHandler('', 'Erro ao baixar relatório')
        return false
      }
      const anchor = angular.element('<a/>')
      anchor.css({
        display: 'none'
      })
      angular.element(document.body).append(anchor)
      anchor.attr({
        href: url,
        target: '_blank'
      })[0].click()
      anchor.remove()
      return true
    }
  }
// eslint-disable-next-line semi
})();
